<template>
  <div class="modal-lei" name="modal_conteudo_lei" @click="fecharModalLei">
    <template v-if="carregandoLegislacao">
      <clip-loader></clip-loader>
    </template>
    <template v-else>
      <div class="caixamodal modal-erro" @click.stop v-if="erroCarregarLegislacao">
        <img
          src="../../assets/images/simbolo-erro.png"
          class="erro-simbolo"
          alt="sÍmbolo de erro"
          title="erro"
        />
        <p>
          Houve um erro ao carregar os dados.
          <br />Por favor tente novamente.
        </p>
      </div>
      <div class="caixamodal" @click.stop v-else>
        <header>
          <router-link :to="{ name: 'IndexLegislacao', query: $route.query }">
            <button type="button" class="botao-fechar"><p>X</p></button>
          </router-link>
          <div class="banner-lei">
            <img
              class="imagem"
              :alt="legislacaoSelecionada.titulo"
              :title="legislacaoSelecionada.titulo"
              :src="legislacaoSelecionada.banner_conteudo"
            />
          </div>

          <h1>{{ titulo }}</h1>
        </header>
        <div class="icons-social">
          <ShareNetwork
            network="whatsapp"
            :url="currentUrl"
            :title="legislacaoSelecionada.titulo"
            :description="legislacaoSelecionada.descricao"
            hashtags="tanalei,governodegoias,casacivil"
          >
            <img
              src="../../assets/images/icon_whatsap.svg"
              class="whatsap"
              alt="compartilhar no Whatsap"
              title="Compartilhar no Whatsap"
            />
          </ShareNetwork>
          <ShareNetwork
            network="facebook"
            :url="currentUrl"
            :title="legislacaoSelecionada.titulo"
            :description="legislacaoSelecionada.descricao"
            hashtags="tanalei,governodegoias,casacivil"
          >
            <img
              src="../../assets/images/icon_face.png"
              class="facebook"
              alt="compartilhar no facebook"
              title="Compartilhar no Facebook"
            />
          </ShareNetwork>
          <ShareNetwork
            network="twitter"
            :url="currentUrl"
            :title="legislacaoSelecionada.titulo"
            :description="legislacaoSelecionada.descricao"
            hashtags="tanalei,governodegoias,casacivil"
          >
            <img
              src="../../assets/images/icon_twitter.png"
              class="twitter"
              alt="compartilhar no X"
              title="Compartilhar no X"
            />
          </ShareNetwork>

          <a v-clipboard:success="copyToClipboard" v-clipboard:copy="currentUrl">
            <img
              src="../../assets/images/icon_copy.png"
              class="copiar"
              alt="copiar URL"
              title="Copiar URL"
            />
          </a>
        </div>
        <div class="conteudo">
          <p class="titulo">
            <strong>{{ legislacaoSelecionada.titulo }}</strong>
          </p>
          <hr />
          <p class="descricao-lei">{{ legislacaoSelecionada.descricao }}</p>
          <hr />
          <div class="conteudo-lei" v-html="legislacaoSelecionada.conteudo"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import slugify from "slugify";

import LegislacaoApi from "../../services/LegislacaoApi";

export default {
  name: "ExibirLegislacaoModal",
  metaInfo() {
    if (!this.legislacaoSelecionada) {
      return {};
    }
    const {
      titulo: title,
      descricao: content,
      banner_conteudo: banner,
      banner_principal_thumbnail: bannerThumbnail,
    } = this.legislacaoSelecionada;

    return {
      title,
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `${title}- Tá na Lei`,
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `${this.urlApp}${this.$route.path}`,
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: bannerThumbnail || banner,
        },
        {
          vmid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: bannerThumbnail || banner,
        },
        {
          vmid: "og:image:width",
          property: "og:image:width",
          content: "400",
        },
        {
          vmid: "og:image:height",
          property: "og:image:height",
          content: "400",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "og:keywords",
          name: "og:keywords",
          content: "tanalei,governodegoias,casacivil",
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          property: "twitter:image",
          content: banner,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content: `${title}- Tá na Lei`,
        },
        {
          vmid: "twitter:site",
          name: "twitter:site",
          content: `${this.urlApp}${this.$route.path}`,
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          property: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  },
  data: function () {
    return {
      carregandoLegislacao: true,
      erroCarregarLegislacao: false,
      legislacaoSelecionada: null,
      urlApi: process.env.VUE_APP_BASE_API_URL,
      urlApp: process.env.VUE_APP_BASE_URL,
    };
  },
  components: {
    ClipLoader,
  },
  created() {
    this.carregarLegislacao();
  },
  watch: {
    $route: function (to, from) {
      if (
        to.name == "exibirLegislacao" &&
        from.name == "exibirLegislacao" &&
        to.params.id != from.params.id
      ) {
        this.carregarLegislacao();
      }
    },
  },
  methods: {
    carregarLegislacao: async function () {
      try {
        this.carregandoLegislacao = true;
        this.erroCarregarLegislacao = false;
        const { data } = await LegislacaoApi.getLegislacao(
          this.$route.params.id
        );
        this.legislacaoSelecionada = data;
        this.carregandoLegislacao = false;
        const slug = this.createSlug();
        if (this.$route.params && this.$route.params.slug != slug) {
          this.$router.replace({
            name: "exibirLegislacao",
            params: { ...this.$route.params, slug },
            query: this.$route.query,
          });
        }
      } catch (err) {
        console.log(err, err.response);
        this.erroCarregarLegislacao = true;
        this.carregandoLegislacao = false;
      }
    },
    fecharModalLei: function () {
      this.$router.push({ name: "IndexLegislacao", query: this.$route.query });
    },
    copyToClipboard: function () {
      this.$toasted.show("URL copiada");
    },
    createSlug: function () {
      if (this.legislacaoSelecionada && this.legislacaoSelecionada.titulo) {
        return slugify(this.legislacaoSelecionada.titulo, {
          lower: true,
          strict: true,
          locale: "pt",
        });
      }
      return undefined;
    },
  },
  computed: {
    currentUrl: function () {
      return window.location.href;
    },
    titulo: function () {
      if (this.legislacaoSelecionada.legislacao_externa) {
        return this.legislacaoSelecionada.legislacao_externa.nome_lei;
      }
      const tipo = this.legislacaoSelecionada.legislacao.tipo_legislacao
        ? this.legislacaoSelecionada.legislacao.tipo_legislacao
        : "";
      return `${tipo} N° ${this.legislacaoSelecionada.legislacao.numero} / ${this.legislacaoSelecionada.legislacao.ano}`;
    },
  },
};
</script>
